export default "__VITE_ASSET__239m1$Hc__"